import { useEffect, useState } from "react";
import { storageData } from "../../services/Services";
import FormContainer from "../../components/RenewalQuestionnaireComp/FormContainer";
import SaveHelpContainer from "../../components/RenewalQuestionnaireComp/SaveHelpContainer";
import RQ_Header from "./RQ_Header";
import AdditionalInfo_Main from "../../components/RenewalQuestionnaireComp/AdditionalInformation/AdditionalInfo_Main";

const RQ_AdditionalInfo = () => {
    const [RQ_Data, setRQ_Data] = useState({});
    const user = storageData.getItem('userData')
    const userData = JSON.parse(user)

    useEffect(() => {
        if (storageData.getItem("sessionDataRQ")) {
            setRQ_Data(storageData.getItem("sessionDataRQ"))
        }
    }, [])

    return (
        <>
            <div className="container widthScreen">
                <RQ_Header userData={userData} screen={'additionalInfo'} />

                <div className="col-12 mt-2 row">
                    <FormContainer Content={AdditionalInfo_Main} params={RQ_Data} saveRQ={setRQ_Data} />
                    <SaveHelpContainer />
                </div>
            </div>
        </>
    )
}

export default RQ_AdditionalInfo